import { setHash } from './hashHistory';

export function replaceHash(hash?: string) {
	setHash(hash ?? '', { replace: true });
}
